const API_BASE = '/api/v1/llm';

function authHeaders(includeJson = true) {
  const token = localStorage.getItem('token');
  return {
    Authorization: `Bearer ${token}`,
    ...(includeJson ? { 'Content-Type': 'application/json' } : {}),
  };
}

async function parseError(response) {
  try {
    const data = await response.json();
    return data.detail || data.error || `Request failed (${response.status})`;
  } catch {
    return `Request failed (${response.status})`;
  }
}

export const llmService = {
  async listConversations() {
    const response = await fetch(`${API_BASE}/conversations`, { headers: authHeaders(false) });
    if (!response.ok) throw new Error(await parseError(response));
    return response.json();
  },

  async createConversation() {
    const response = await fetch(`${API_BASE}/conversations`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({}),
    });
    if (!response.ok) throw new Error(await parseError(response));
    return response.json();
  },

  async getConversation(id) {
    const response = await fetch(`${API_BASE}/conversations/${id}`, { headers: authHeaders(false) });
    if (!response.ok) throw new Error(await parseError(response));
    return response.json();
  },

  async deleteConversation(id) {
    const response = await fetch(`${API_BASE}/conversations/${id}`, {
      method: 'DELETE',
      headers: authHeaders(false),
    });
    if (!response.ok) throw new Error(await parseError(response));
    return response.json();
  },

  async clearHistory() {
    const response = await fetch(`${API_BASE}/conversations`, {
      method: 'DELETE',
      headers: authHeaders(false),
    });
    if (!response.ok) throw new Error(await parseError(response));
    return response.json();
  },

  async translate(text) {
    const response = await fetch(`${API_BASE}/translate`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ text }),
    });
    if (!response.ok) throw new Error(await parseError(response));
    return response.json();
  },

  async chat({ conversationId, message, onConversation, onStatus, onToken, onDone, onError }) {
    try {
      const response = await fetch(`${API_BASE}/chat`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify({
          message,
          ...(conversationId ? { conversation_id: conversationId } : {}),
        }),
      });

      if (!response.ok) throw new Error(await parseError(response));

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';
      let currentEvent = '';
      let doneFired = false;

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        buffer = lines.pop() || '';

        for (const line of lines) {
          if (line.startsWith('event: ')) {
            currentEvent = line.slice(7).trim();
          } else if (line.startsWith('data: ')) {
            try {
              const data = JSON.parse(line.slice(6));
              if (currentEvent === 'conversation') onConversation?.(data);
              else if (currentEvent === 'status') onStatus?.(data.status);
              else if (currentEvent === 'token') onToken?.(data.token);
              else if (currentEvent === 'done' && !doneFired) {
                doneFired = true;
                onDone?.(data);
              }
            } catch {
              // skip malformed
            }
          }
        }
      }

      if (!doneFired) onDone?.();
    } catch (err) {
      onError?.(err.message || 'Something went wrong');
    }
  },
};
